<template>
  <b-modal
    id="modal-filter-videohistory-trackvision"
    size="md"
    :title="'Filter'"
    modal-class="modal-filter mc-videohistory__modal-filter-trackvision"
    hide-header-close
    scrollable
    @show="onShowModal"
    @hide="onCloseModal"
  >
    <div class="mc-modal__filter-item">
      <div>
        <FormulateInput
          v-bind="vehicleFields"
          :value="vehicleDetail.licensePlate"
          @update:fullObject="updateFullObjectsVehicle($event)"
        />
        <span class="mc-label-required">
          <span class="mc-required">*</span>
          <span class="mc-label">
            {{ $t('videoHistory.mustFilled') }}
          </span>
        </span>
      </div>
    </div>
    <div class="mc-modal__filter-item filter-periode">
      <label class="formulate-input-label">
        {{ $t('videoHistory.videoPeriod') }}
        <i
          v-b-tooltip.hover.left="$t('videoHistory.infoPeriode')"
          class="mc-fa icon-outline_info icon-primary icon-sm"
        ></i>
      </label>

      <div>
        <date-picker
          ref="periodePicker"
          v-model="formValues.period"
          type="datetime"
          :placeholder="$t('global.action.selectDate')"
          format="DD MMM YYYY HH:mm"
          value-type="YYYY-MM-DD HH:mm"
          range-separator=" - "
          range
          :class="datePickerClasses"
          :confirm="false"
          :clearable="false"
          :disabled-date="disableFutureDates"
          :disabled="$store.state.vehicle.isLoadingVehicleVideos"
          :lang="datePickerLang"
          :shortcuts="[]"
          @pick="pickDate"
        >
          <template #sidebar>
            <button
              v-for="(shortcut, index) in makeShortcuts"
              :key="index"
              type="button"
              class="mx-btn mx-btn-text mx-btn-shortcut"
              :class="{ active: isShortcutActive(shortcut) }"
              @click="selectShortcut(shortcut)"
            >
              {{ shortcut.text }}
            </button>
          </template>
          <template #input>
            <input
              v-if="formValues.period.length"
              name="date"
              type="text"
              autocomplete="off"
              :placeholder="$t('global.action.selectDate')"
              class="mx-input"
              :value="`${momentDMYH(formValues.period[0])} - ${momentTime(formValues.period[1])}`"
              :disabled="$store.state.vehicle.isLoadingVehicleVideos"
            />
          </template>
          <template #footer>
            <span class="mr-3">
              {{ momentDMYH(formValues.period[0]) }} -
              {{ momentTime(formValues.period[1]) }}
            </span>
            <b-button class="mx-2" variant="outline-primary" @click="cancelCalendar">
              {{ $t('global.action.cancel') }}
            </b-button>
            <b-button
              variant="primary"
              :disabled="$store.state.vehicle.isLoadingVehicleVideos"
              @click="applied"
            >
              {{ $t('global.action.apply') }}
            </b-button>
          </template>
        </date-picker>

        <span class="mc-label-required">
          <span class="mc-required">*</span>
          <span class="mc-label">
            {{ $t('videoHistory.mustFilled') }}
          </span>
        </span>
      </div>
    </div>
    <div class="mc-modal__filter-item">
      <label class="formulate-input-label">{{ $t('videoHistory.channelCamera') }}</label>
      <div>
        <multiselect
          v-model="formValues.camera"
          class="w-50"
          :options="cameraOptions"
          label="label"
          :placeholder="$t('global.form.select') + ' ' + $t('trackVideo.camera')"
        />
        <span class="mc-label-required">
          <span class="mc-required">*</span>
          <span class="mc-label">
            {{ $t('videoHistory.mustFilled') }}
          </span>
        </span>
      </div>
    </div>
    <template #modal-footer="{ cancel }">
      <b-row class="modal__filter-footer mx-0">
        <b-col sm="12" md="12" class="modal__filter-footer-btn">
          <McButton
            variant="secondary"
            class="me-2"
            :text="$t('global.action.cancel')"
            @click="cancel"
          />
          <McButton
            variant="primary"
            :text="$t('global.action.apply')"
            :disabled="btnAcceptFilterDisabled"
            @click="handleAccept"
          />
        </b-col>
      </b-row>
    </template>
  </b-modal>
</template>

<script>
import McButton from '@/components/McButton'
import DatePicker from 'vue2-datepicker'
import datePickerLang from '@/helpers/date-picker-lang'
import moment from 'moment'
import { Helper } from '@/mixin/helper'
import Multiselect from 'vue-multiselect'
import { mapGetters, mapState } from 'vuex'
import {
  GET_VEHICLE_VIDEO_TRACKER_BY_VEHICLE_ID,
  GET_VEHICLE_VIDEO_FILTER,
} from '../../../services/api/trackvideo/video'
import VideoStatusBadge from '@/components/VideoStatusBadge'

export default {
  name: 'ModalFilterVideoHistoryTrackvision',
  components: {
    DatePicker,
    McButton,
    Multiselect,
  },
  mixins: [Helper],
  data() {
    return {
      formValues: {
        vehicleId: null,
        camera: null,
        period: [],
        tempPeriod: [],
      },
      cameraOptions: [],
      vehicleFilterList: {},
      loadingLoadStatusText: false,
      tempVehicleDetail: {
        licensePlate: null,
        vehicleType: null,
        vehicleCategory: null,
        manufacturer: null,
        imei: null,
        deviceName: null,
        deviceCode: null,
        id: null,
      },
      tempStatusText: null,
      tempDeviceTimezone: null,
      vGroups: [],
    }
  },

  computed: {
    ...mapState('vehicle', ['statusText', 'listVgroups', 'listVehicle', 'listVehicleType']),
    ...mapGetters('vehicle', ['vehicleId', 'vehicleDetail', 'vehicleStatusByVehicleId']),
    ...mapGetters({
      getFeatureFlagValue: 'identity/getFeatureFlagValue',
    }),
    ...mapGetters({
      hasAccess: 'identity/hasAccess',
    }),
    isVideoDemo() {
      if (!this.$route.query?.vehicleId) {
        return false
      }
      const dataDemoVideoHistory = this.getFeatureFlagValue('vsms2_trackvision2_playback_demo_id')
      return Object.keys(dataDemoVideoHistory).includes(this.$route.query?.vehicleId.toString())
    },
    isHasAccessSwitchView() {
      return this.hasAccess(['b3n-trackvision-toggle-video-status:read'])
    },
    isNewView() {
      const isNewView = JSON.parse(localStorage.getItem('live-streaming-switch-view-on')) ?? true
      return isNewView
    },
    vehicleFields() {
      const tableFields = [
        {
          label: this.$t('report.fields.licensePlate'),
          key: 'licensePlate',
          isSortable: true,
        },
        ...((this.hasAccess(['b3j-trackvision-video-history-status:read']) &&
          !this.isHasAccessSwitchView) ||
        (this.isHasAccessSwitchView && this.isNewView)
          ? [
              {
                label: 'Status Video',
                key: 'vehicleId',
                isSortable: false,
                isSlot: true,
                slotComponent: VideoStatusBadge,
                customProps: (item) => ({
                  isOnline: this.getVideoStatusIsOnline(item.vehicleId),
                }),
              },
            ]
          : []),
        {
          label: this.$t('report.fields.fleetType'),
          key: 'vehicleType',
          isSortable: false,
          formatter: (value) => {
            return (
              (value.manufacturer ?? '-') +
              ' / ' +
              (value.model ?? '-') +
              ' / ' +
              (value.type ?? '-')
            )
          },
        },
        {
          label: this.$t('report.fields.vehicleGroup'),
          key: 'vehicle2Vgroup',
          isSortable: false,
          formatter: (value) => {
            return value && value.length > 0 ? value.map((v) => v.vgroup.name).join(', ') : '-'
          },
        },
      ]
      return {
        name: 'license-plate-filter-video-history',
        isShow: true,
        label: this.$t('report.fields.licensePlate'),
        type: 'trackvision-filter-value-help',
        placeholder: `${this.$t('global.action.choose')} ${this.$t('report.fields.licensePlate')}`,
        trackBy: 'vehicleId',
        displayedBy: 'licensePlate',
        listGetter: (filter) => this.getVehicleList(filter),
        multiple: false,
        tableFields: tableFields,
        rowCanClick: (vehicleId) => {
          if (
            (!this.hasAccess(['b3j-trackvision-video-history-status:read']) &&
              !this.isHasAccessSwitchView) ||
            (this.isHasAccessSwitchView && !this.isNewView)
          )
            return true
          return this.getVideoStatusIsOnline(vehicleId)
        },
        filters: [
          {
            label: this.$t('report.fields.fleetType'),
            key: 'vehicleType',
            data: this.listVehicleType.length
              ? this.listVehicleType.map(({ vehicleTypeId, manufacturer, model, type }) => ({
                  name: (manufacturer ?? '-') + ' / ' + (model ?? '-') + ' / ' + (type ?? '-'),
                  id: vehicleTypeId,
                }))
              : [],
            model: [],
          },
          {
            label: this.$t('report.fields.vehicleGroup'),
            key: 'vgroup',
            data: this.listVgroups.length
              ? this.listVgroups.map(({ vgroupId, vgroup: { name } }) => ({ id: vgroupId, name }))
              : [],
            model: [],
          },
        ],
      }
    },
    datePickerClasses() {
      return {
        'mc-history-modal__list-date': true,
        'mc-videohistory-button-disabled': this.$store.state.vehicle.isLoadingVehicleVideos,
      }
    },
    datePickerLang() {
      return datePickerLang()
    },
    btnAcceptFilterDisabled() {
      return !this.formValues.vehicleId || !this.formValues.camera || !this.formValues.period.length
    },
    makeShortcuts() {
      return [
        { text: this.$t('global.time.today'), onClick: () => this.shortcutsToday },
        { text: this.$t('global.time.yesterday'), onClick: () => this.shortcutsYesterday },
      ]
    },
    shortcutsToday() {
      const dateStart = new Date()
      dateStart.setHours(0, 0, 0, 0)
      return [dateStart, new Date()]
    },
    shortcutsYesterday() {
      const dateStart = new Date()
      const dateEnd = new Date()
      dateEnd.setTime(dateEnd.getTime() - 3600 * 1000 * 24)
      dateStart.setTime(dateStart.getTime() - 3600 * 1000 * 24)
      dateStart.setHours(0, 0, 0, 0)
      dateEnd.setHours(23, 59, 59, 999)
      return [dateStart, dateEnd]
    },

    getVideoStatusIsOnline() {
      return (vehicleId) => {
        const vehicleStatus = this.getVehicleStatusByVehicleId(vehicleId)

        if (this.checkIsDemo(vehicleId)) return true
        if (!vehicleStatus) return false

        let secondEngineOn = 60
        let secondEngineOff = 600
        if (this.getFeatureFlagValue('trackvision_video_offline_acc_on')) {
          secondEngineOn = this.getFeatureFlagValue('trackvision_video_offline_acc_on')
        }
        if (this.getFeatureFlagValue('trackvision_video_offline_acc_off')) {
          secondEngineOff = this.getFeatureFlagValue('trackvision_video_offline_acc_off')
        }

        const lastReceive = vehicleStatus.lastReceive
        const engineOn = vehicleStatus.engineOn
        const diffMinutes = this.getDurationBetween2Dates(lastReceive, this.nowUtc())

        if (engineOn) return diffMinutes < secondEngineOn / 60
        return diffMinutes < secondEngineOff / 60
      }
    },
  },

  watch: {
    '$store.state.vehicle.channelActive'(channel) {
      const cameraPicked = this.cameraOptions.find((item) => item.value === channel)
      this.formValues.camera = cameraPicked
    },
    statusText(statusText) {
      if (!statusText) return
      this.cameraOptions = []
      statusText.split(',').forEach((row, index) => {
        this.cameraOptions.push({
          value: Number(row),
          label: `${this.$t('trackVideo.camera')} ${index + 1}`,
        })
      })
      this.tempStatusText = statusText
    },
  },

  methods: {
    selectShortcut(shortcut) {
      const value = shortcut.onClick()
      if (value) this.$refs.periodePicker.emitValue(value)
    },
    isShortcutActive(shortcut) {
      if (!Array.isArray(this.formValues.period) || this.formValues.period.length !== 2) return false

      const value = shortcut.onClick()
      return value.every((date, index) =>
        moment(date).isSame(moment(this.formValues.period[index]), 'day')
      )
    },
    checkIsDemo(vehicleId) {
      const dataDemoVideoHistory = this.getFeatureFlagValue('vsms2_trackvision2_playback_demo_id')
      return Object.keys(dataDemoVideoHistory)
        .map((id) => parseInt(id))
        .includes(vehicleId)
    },
    getVehicleStatusByVehicleId(vehicleId) {
      if (this.checkIsDemo(vehicleId)) {
        return {
          ...this.vehicleStatusByVehicleId(vehicleId),
          calculatedMotionStatus: 'M',
        }
      }
      return this.vehicleStatusByVehicleId(vehicleId)
    },
    resetFormState() {
      this.formValues.vehicleId = null
      this.formValues.camera = null
      this.formValues.period = []
      this.formValues.tempPeriod = []
      this.cameraOptions = []
    },
    updateFullObjectsVehicle(value) {
      this.formValues.vehicleId = value.vehicleId
      this.setStatusText(value.statusText)
    },
    async setStatusText(statusText) {
      this.cameraOptions = []
      await this.$nextTick()
      statusText.split(',').forEach((row, index) => {
        this.cameraOptions.push({
          value: Number(row),
          label: `${this.$t('trackVideo.camera')} ${index + 1}`,
        })
      })
      this.formValues.camera = this.cameraOptions[0]
    },
    async getVehicleVideoTrackerByVehicleId(vehicleId) {
      const response = await this.$apollo.query({
        query: GET_VEHICLE_VIDEO_TRACKER_BY_VEHICLE_ID,
        variables: {
          filter: {
            vehicleId,
          },
        },
        fetchPolicy: 'no-cache',
      })
      if (!response.data.vehicleVideoTrackers.isSuccessful) return
      const vehicle = response.data.vehicleVideoTrackers.vehicleVideoTrackers[0].vehicle
      const parent = response.data.vehicleVideoTrackers.vehicleVideoTrackers[0].parent
      const statusText = response.data.vehicleVideoTrackers.vehicleVideoTrackers[0].statusText
      const deviceName = Helper.methods.getDeviceType(vehicle.device.deviceCode)
      const deviceTimezone = vehicle.device.timezone
      const vehicleDetail = {
        licensePlate: parent ? parent?.vehicle?.licensePlate : vehicle.licensePlate,
        vehicleType: vehicle.vehicleType.type,
        vehicleCategory: vehicle.vehicleType.category,
        manufacturer: vehicle.vehicleType.manufacturer,
        imei: vehicle.imei,
        deviceName,
        deviceCode: vehicle.device.deviceCode,
        id: vehicle.id,
      }

      this.tempVehicleDetail = vehicleDetail
      this.tempStatusText = statusText
      this.tempDeviceTimezone = deviceTimezone
    },
    async getVehicleList(opt) {
      const { orderBy, search } = opt
      const response = await this.$apollo.query({
        query: GET_VEHICLE_VIDEO_FILTER,
        fetchPolicy: 'no-cache',
        variables: {
          filter: {
            orderBy: orderBy ?? JSON.stringify({ licensePlate: 'asc' }),
            search: search ?? undefined,
            vgroupId: opt.vgroup ?? undefined,
            vehicleTypeId: opt.vehicleType ?? undefined,
            motionStatus: this.hasAccess(['assisted_motion_status:read'])
              ? ['assisted', 'idle', 'moving', 'offline', 'parking', 'unknown']
              : undefined,
          },
        },
      })
      let dataResponse = response.data.vehicleVideoTrackers.vehicleVideoTrackers
      dataResponse.forEach((data) => {
        const groups = data.vehicle.vehicle2Vgroup
        data.licensePlate = data.parent?.vehicle
          ? data.parent?.vehicle?.licensePlate
          : data.vehicle.licensePlate
        data.vehicle2Vgroup = groups
        data.vehicleType = data.vehicle.vehicleType
      })

      dataResponse.sort((a, b) => {
        // First criterion: Device Online/Offline status (online first)
        const aIsOnline = this.getVideoStatusIsOnline(a.vehicleId)
        const bIsOnline = this.getVideoStatusIsOnline(b.vehicleId)
        if (aIsOnline !== bIsOnline) {
          return aIsOnline ? -1 : 1 // Online comes first
        }
        return a.licensePlate.toLowerCase().localeCompare(b.licensePlate.toLowerCase())
      })

      return {
        data: dataResponse,
        ids: dataResponse.map((data) => data.vehicleId), // ids vehicle
        pagination: {
          page: 1,
          show: dataResponse.length,
          total: dataResponse.length,
        },
      }
    },
    duplicatePeriodeForTemp() {
      this.formValues.tempPeriod = [...this.formValues.period]
    },
    updatePeriodState(periode) {
      this.formValues.period = [...periode]
    },
    closePopup() {
      if (this.$refs.periodePicker) {
        this.$refs.periodePicker.closePopup()
      }
    },
    disableFutureDates(date) {
      const currentDate = new Date()

      return date > currentDate
    },
    cancelCalendar() {
      this.formValues.period = [...this.formValues.tempPeriod]
      this.closePopup()
    },
    async pickDate(date) {
      this.duplicatePeriodeForTemp()
      const pickerRefs = this.$refs.periodePicker.$refs.picker
      const overrideDefaultTime = moment(date)
        .set({
          hour: '23',
          minute: '59',
          second: '59',
        })
        .toDate()
      if (!pickerRefs.defaultTimeVisible) {
        this.updatePeriodState([date, overrideDefaultTime])
        await this.$nextTick()
        pickerRefs.value[0] = date
        pickerRefs.value[1] = overrideDefaultTime
        pickerRefs.openTimePanel()
      }
    },
    applied() {
      this.duplicatePeriodeForTemp()
      this.closePopup()
    },
    onShowModal() {
      if (this.vehicleId) {
        this.formValues.period = [...this.$store.state.vehicle.period]
        this.formValues.tempPeriod = [...this.$store.state.vehicle.period]
        this.formValues.vehicleId = this.vehicleId

        this.tempVehicleDetail = this.$store.state.vehicle.vehicleDetail

        const channel = this.$store.state.vehicle.channelActive
        const cameraPicked = this.cameraOptions.find((item) => item.value === channel)

        this.formValues.camera = cameraPicked
      } else {
        this.resetFormState()
        this.$store.commit('vehicle/clearVehicleDetail')
      }
    },
    onCloseModal() {},
    async handleAccept() {
      await this.getVehicleVideoTrackerByVehicleId(this.formValues.vehicleId)
      this.$bvModal.hide('modal-filter-videohistory-trackvision')
      const isNewVehicleFilter = this.vehicleId != this.formValues.vehicleId

      // update global state filter
      this.$store.commit('vehicle/setVehicleId', this.formValues.vehicleId)
      this.$store.commit('vehicle/setStatusText', this.tempStatusText)
      this.$store.commit('vehicle/setDeviceTimezone', this.tempDeviceTimezone)

      this.$store.commit(
        'vehicle/setVehicleHistoryPeriod',
        this.formValues.period.map((p) => this.formatDateToUtc(p))
      )
      this.$store.commit('vehicle/setVehicleDetail', { vehicleDetail: this.tempVehicleDetail })

      this.$forceUpdate()
      await this.delay(250)

      this.$store.commit('vehicle/setChannelActive', this.formValues.camera.value)

      if (isNewVehicleFilter) {
        this.$router.push({
          name: 'Video History Trackvision',
          query: { vehicleId: this.formValues.vehicleId },
        })
      }

      this.$emit('applyFilter')
    },
  },
}
</script>

<style lang="scss">
#license-plate-filter-video-history-modal-value-help {
  .multiselect__content {
    width: 100%;
    .multiselect__element {
      span {
        white-space: wrap;
      }
      .multiselect__option--selected {
        padding-right: 24px;
      }
    }
  }
  table {
    tbody {
      tr {
        td:nth-child(2),
        td:nth-child(3),
        td:nth-child(4) {
          max-width: 136px;
          white-space: normal;
          text-overflow: ellipsis;
          overflow: hidden;
        }
      }
    }
  }
}
</style>
